<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-container>
      <b-input-group 
        class="my-3"
        prepend="Import bestand (xlsx)" 
        style="z-index: 10"
      >
        <b-file
          v-model="upload"
          accept=".xlsx"
          placeholder="Kies bestand of sleep hier in..."
          drop-placeholder="Laat maar los..."
          browse-text="Kies bestand"
        />
        <b-input-group-append>
          <b-button 
            style="z-index: 100" 
            @click="uploadFile()"
          >
            Upload
          </b-button>
        </b-input-group-append>
      </b-input-group>
      
      <small>{{ uploadurl }}</small>
      
      <b-card 
        v-if="result" 
      >
        {{ result.upload.message }}
        <b-alert 
          v-for="(error,index) in result.upload.result.errors" 
          :key="index"
          variant="danger" 
          show
        >
          {{ error }}
        </b-alert>
      </b-card>
      <b-table 
        :items="imports.data"
        :fields="['id','bronImport','count','geimporteerdOp']"
        bordered
        striped 
        small
      >
        <template #cell(bronImport)="data">
          {{ data.item.bronImport }} 
          <b-button 
            variant="danger" 
            small
            @click="() => deleteImport(data.item.bronImport)"
          >
            delete
          </b-button>
        </template>
      </b-table>
      <b-table 
        :items="log"
        small 
        bordered
        striped
        caption="Laatste 10 aangemaakte berichten"
        caption-top
      />
    </b-container>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
  name: "RelatieImportStatus",
  mixins: [serviceMixin],
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      log: [],
      imports: [],
      result: null,
      upload: null,
      busy:false
    };
  },
  computed: {
    uploadurl: function() {
      return `/relatie/${this.id}/status/import`;
    }
  },
  mounted: function() {
    this.getImports();
    this.getLastStatusBerichten()
  },
  methods: {
    deleteImport(filename) {
      var id = this.$props.id;
      console.log(filename);
      this.deletePost(`/relatie/${id}/status/import`, {filename: filename}).then((response) => {
        console.log(response);
        this.getImports();
      }).finally(() => (this.busy = false));
    },
    getImports() {
      var id = this.$props.id;
      this.get(`/relatie/${id}/status/import`).then((response) => {
        this.imports = response.data;
      }).finally(() => (this.busy = false));
    },
    getLastStatusBerichten() {
      // var nr = 10;
      var id = this.$props.id;
      this.get(`/relatie/${id}/status/log`, {relatieId: id}).then((response) => {
        this.log = response.data.data;
      }).finally(() => (this.busy = false));
    },  
    uploadFile() {
      console.log("start upload");
      var vm = this;
      this.busy = true;
      var formdata = new FormData();
      var file_name = this.upload.name;
      formdata.append("file_content", this.upload);
      formdata.append("file_name", this.upload.name);
      formdata.append("relatieId", this.id);
      this.uploadDocument(this.uploadurl, formdata)
        .then(function(response) {
          vm.result= {
            file: file_name,
            upload: response.data
          };
          vm.getImports();
        })
        .catch(function(error) {
          console.log(error);
        }).finally(() => (vm.busy = false));
    },
    uploadDocument(endpoint, data) {
      return this.postMultipart(endpoint, data);
    },
    
  }
}
</script>